
import { defineComponent } from "vue";
import User from "../interfaces/User/User.interface";
import { useStore } from "../store";
export default defineComponent({
  name: "UserCard",
  props: {
    user: {
      required: true,
      type: Object as () => User,
    },
  },
  setup(props, { emit }) {
    const store = useStore();
    const deleteUser = async () => {
      if (window.confirm("Are you sure you want do delete the user?")) {
        if (await store.dispatch("deleteUser", props.user.userId)) {
          emit("reload");
        }
      }
    };

    return {
      deleteUser,
    };
  },
});
